import { useSelector } from "react-redux";

export default function useUser() {
    const user = useSelector((state) => state.auth.user);
    const isLoggedIn = !!user; // boolean

    return { user, isLoggedIn };
}
